import { parsePhoneNumberFromString } from 'libphonenumber-js'

// Generic, cross-module input validators. Domain-specific validators
// (bank account, KYC, etc.) live inside their owning module under
// `<module>/utils/<concern>ValidatorUtils.ts` — never here. See
// architecture-principles §13: shared/ must be business-agnostic.

// ─── Format constants ────────────────────────────────────────────────────────

const MOBILE_MIN_DIGITS = 8
const MOBILE_MAX_DIGITS = 15

// ─── Validators ──────────────────────────────────────────────────────────────

export function isValidEmail(email: string): boolean {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(email)
}

export function validateFullName(value: string): string {
  return value.trim().length > 1 ? '' : 'Please enter your full name'
}

export function validateFirstName(value: string): string {
  if (!value.trim()) return 'First name is required'
  if (!/^[A-Za-z\s]+$/.test(value.trim())) {
    return 'First name can only contain letters'
  }
  return ''
}

export function validateLastName(value: string): string {
  if (!value.trim()) return 'Last name is required'
  if (!/^[A-Za-z\s]+$/.test(value.trim())) {
    return 'Last name can only contain letters'
  }
  return ''
}

export function validateEmail(value: string): string {
  if (!value.trim()) return 'Email is required'
  return isValidEmail(value.trim()) ? '' : 'Please enter a valid email address'
}

export function validateMobile(value: string, countryCode?: string): string {
  const normalizedValue = value.trim()
  const digitsOnly = normalizedValue.replace(/\D/g, '')

  if (!normalizedValue) return 'Mobile number is required'
  if (!/^\+?\d+$/.test(normalizedValue)) {
    return 'Please enter a valid mobile number'
  }
  if (digitsOnly.length < MOBILE_MIN_DIGITS || digitsOnly.length > MOBILE_MAX_DIGITS) {
    return `Mobile number must be between ${MOBILE_MIN_DIGITS} and ${MOBILE_MAX_DIGITS} digits`
  }

  const parsedNumber = parsePhoneNumberFromString(
    normalizedValue.startsWith('+') ? normalizedValue : `${countryCode ?? ''}${digitsOnly}`,
  )

  if (!parsedNumber?.isValid()) {
    return 'Please enter a valid mobile number'
  }

  return ''
}
